// const cdn_url = {name: 'Https://res.cloudinary.com/aviabird/image/upload/q_60/v1529433193/angularspree/';

export const DEFAULT_APP_DATA = {

    country_list: [
        {name: 'Afghanistan'},
        {name: 'Albania'},
        {name: 'Algeria'},
        {name: 'Andorra'},
        {name: 'Angola'},
        {name: 'Anguilla'},
        {name: 'Antigua & Barbuda'},
        {name: 'Argentina'},
        {name: 'Armenia'},
        {name: 'Australia'},
        {name: 'Austria'},
        {name: 'Azerbaijan'},
        {name: 'Bahamas'},
        {name: 'Bahrain'},
        {name: 'Bangladesh'},
        {name: 'Barbados'},
        {name: 'Belarus'},
        {name: 'Belgium'},
        {name: 'Belize'},
        {name: 'Benin'},
        {name: 'Bermuda'},
        {name: 'Bhutan'},
        {name: 'Bolivia'},
        {name: 'Bosnia & Herzegovina'},
        {name: 'Botswana'},
        {name: 'Brazil'},
        {name: 'Brunei Darussalam'},
        {name: 'Bulgaria'},
        {name: 'Burkina Faso'},
        {name: 'Burundi'},
        {name: 'Cambodia'},
        {name: 'Cameroon'},
        {name: 'Canada'},
        {name: 'Cape Verde'},
        {name: 'Cayman Islands'},
        {name: 'Central African Republic'},
        {name: 'Chad'},
        {name: 'Chile'},
        {name: 'China'},
        {name: 'China - Hong Kong / Macau'},
        {name: 'Colombia'},
        {name: 'Comoros'},
        {name: 'Congo'},
        {name: 'Congo, Democratic Republic of(DRC)'},
        {name: 'Costa Rica'},
        {name: 'Croatia'},
        {name: 'Cuba'},
        {name: 'Cyprus'},
        {name: 'Czech Republic'},
        {name: 'Denmark'},
        {name: 'Djibouti'},
        {name: 'Dominica'},
        {name: 'Dominican Republic'},
        {name: 'Ecuador'},
        {name: 'Egypt'},
        {name: 'El Salvador'},
        {name: 'Equatorial Guinea'},
        {name: 'Eritrea'},
        {name: 'Estonia'},
        {name: 'Eswatini'},
        {name: 'Ethiopia'},
        {name: 'Fiji'},
        {name: 'Finland'},
        {name: 'France'},
        {name: 'French Guiana'},
        {name: 'Gabon'},
        {name: 'Gambia, Republic of The'},
        {name: 'Georgia'},
        {name: 'Germany'},
        {name: 'Ghana'},
        {name: 'Great Britain'},
        {name: 'Greece'},
        {name: 'Grenada'},
        {name: 'Guadeloupe'},
        {name: 'Guatemala'},
        {name: 'Guinea'},
        {name: 'Guinea - Bissau'},
        {name: 'Guyana'},
        {name: 'Haiti'},
        {name: 'Honduras'},
        {name: 'Hungary'},
        {name: 'Iceland'},
        {name: 'India'},
        {name: 'Indonesia'},
        {name: 'Iran'},
        {name: 'Iraq'},
        {name: 'Israel and the Occupied Territories'},
        {name: 'Italy'},
        {name: 'Ivory Coast'},
        {name: 'Jamaica'},
        {name: 'Japan'},
        {name: 'Jordan'},
        {name: 'Kazakhstan'},
        {name: 'Kenya'},
        {name: 'Korea, Democratic Republic of(North Korea)'},
        {name: 'Korea, Republic of(South Korea)'},
        {name: 'Kosovo'},
        {name: 'Kuwait'},
        {name: 'Kyrgyz Republic(Kyrgyzstan)'},
        {name: 'Laos'},
        {name: 'Latvia'},
        {name: 'Lebanon'},
        {name: 'Lesotho'},
        {name: 'Liberia'},
        {name: 'Libya'},
        {name: 'Liechtenstein'},
        {name: 'Lithuania'},
        {name: 'Luxembourg'},
        {name: 'Madagascar'},
        {name: 'Malawi'},
        {name: 'Malaysia'},
        {name: 'Maldives'},
        {name: 'Mali'},
        {name: 'Malta'},
        {name: 'Martinique'},
        {name: 'Mauritania'},
        {name: 'Mauritius'},
        {name: 'Mayotte'},
        {name: 'Mexico'},
        {name: 'Moldova, Republic of'},
        {name: 'Monaco'},
        {name: 'Mongolia'},
        {name: 'Montenegro'},
        {name: 'Montserrat'},
        {name: 'Morocco'},
        {name: 'Mozambique'},
        {name: 'Myanmar / Burma'},
        {name: 'Namibia'},
        {name: 'Nepal'},
        {name: 'New Zealand'},
        {name: 'Nicaragua'},
        {name: 'Niger'},
        {name: 'Nigeria'},
        {name: 'North Macedonia, Republic of'},
        {name: 'Norway'},
        {name: 'Oman'},
        {name: 'Pacific Islands'},
        {name: 'Pakistan'},
        {name: 'Panama'},
        {name: 'Papua New Guinea'},
        {name: 'Paraguay'},
        {name: 'Peru'},
        {name: 'Philippines'},
        {name: 'Poland'},
        {name: 'Portugal'},
        {name: 'Puerto Rico'},
        {name: 'Qatar'},
        {name: 'Reunion'},
        {name: 'Romania'},
        {name: 'Russian Federation'},
        {name: 'Rwanda'},
        {name: 'Saint Kitts and Nevis'},
        {name: 'Saint Lucia'},
        {name: 'Saint Vincent and the Grenadines'},
        {name: 'Samoa'},
        {name: 'Sao Tome and Principe'},
        {name: 'Saudi Arabia'},
        {name: 'Senegal'},
        {name: 'Serbia'},
        {name: 'Seychelles'},
        {name: 'Sierra Leone'},
        {name: 'Singapore'},
        {name: 'Slovak Republic(Slovakia)'},
        {name: 'Slovenia'},
        {name: 'Solomon Islands'},
        {name: 'Somalia'},
        {name: 'South Africa'},
        {name: 'South Sudan'},
        {name: 'Spain'},
        {name: 'Sri Lanka'},
        {name: 'Sudan'},
        {name: 'Suriname'},
        {name: 'Sweden'},
        {name: 'Switzerland'},
        {name: 'Syria'},
        {name: 'Tajikistan'},
        {name: 'Tanzania'},
        {name: 'Thailand'},
        {name: 'Netherlands'},
        {name: 'Timor Leste'},
        {name: 'Togo'},
        {name: 'Trinidad & Tobago'},
        {name: 'Tunisia'},
        {name: 'Turkey'},
        {name: 'Turkmenistan'},
        {name: 'Turks & Caicos Islands'},
        {name: 'Uganda'},
        {name: 'Ukraine'},
        {name: 'United Arab Emirates'},
        {name: 'United States of America(USA)'},
        {name: 'Uruguay'},
        {name: 'Uzbekistan'},
        {name: 'Venezuela'},
        {name: 'Vietnam'},
        {name: 'Virgin Islands(UK)'},
        {name: 'Virgin Islands(US)'},
        {name: 'Yemen'},
        {name: 'Zambia'},
        {name: 'Zimbabwe'}
    ],

};
